export default class ShopSubscribe extends HTMLElement {
  constructor() {
    super()

    this.innerHTML = `
      <div class="px-4 py-3 uppercase">
        <p>Subscribe</p>
      </div>
    `
  }
}

customElements.define('shop-subscribe', ShopSubscribe)
